import { render, staticRenderFns } from "./ed-section-material-title.vue?vue&type=template&id=8eee5766&scoped=true&"
import script from "./ed-section-material-title.ts?vue&type=script&lang=ts&"
export * from "./ed-section-material-title.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-material-title.scss?vue&type=style&index=0&id=8eee5766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eee5766",
  null
  
)

export default component.exports